import type { User } from "schemas/generated/user";

import {
  getDashboardLandingPath,
  getDashboardSurface,
} from "replo-utils/lib/dashboardRoutes";

type LandingUser = Pick<
  User,
  | "defaultProjectId"
  | "defaultProjectHostingType"
  | "defaultProjectAgentEnabledAt"
>;

// user.get already resolved the last visited project (or its fallback); this picks its dashboard.
export function getProjectLandingPath(
  user: LandingUser | null | undefined,
): string | null {
  if (!user?.defaultProjectId) {
    return null;
  }
  return getDashboardLandingPath({
    projectId: user.defaultProjectId,
    surface: getDashboardSurface({
      hostingType: user.defaultProjectHostingType ?? null,
      agentEnabledAt: user.defaultProjectAgentEnabledAt ?? null,
    }),
  });
}
